import React, { useState, useEffect } from "react";

export default function INDIANPOLITICStest(props) {
  const correctAnswers = [1, 3, 0, 0, 3, 1, 0, 3, 0, 0, 0, 0, 2, 1, 0, 1, 3, 2, 1, 1, 1, 3, 3, 3, 0];
  const que = {
    q1: {
      string: "1. Who was the first Prime Minister of India?",
      options: ["Indira Gandhi", "Jawaharlal Nehru", "Sardar Vallabhbhai Patel", "Lal Bahadur Shastri"],
      ans: 1
    },
    q2: {
      string: "2. Which political party was founded by Bal Gangadhar Tilak and Annie Besant?",
      options: ["Indian National Congress", "All India Forward Bloc", "Swatantra Party", "Home Rule League"],
      ans: 3
    },
    q3: {
      string: "3. Who is known as the 'Father of the Indian Constitution'?",
      options: ["B.R. Ambedkar", "Mahatma Gandhi", "Jawaharlal Nehru", "Sardar Vallabhbhai Patel"],
      ans: 0
    },
    q4: {
      string: "4. Which year saw the formation of the first non-Congress government at the center?",
      options: ["1977", "1984", "1991", "2004"],
      ans: 0
    },
    q5: {
      string: "5. Who was the first woman Chief Minister of an Indian state?",
      options: ["Indira Gandhi", "Jayalalithaa", "Mamata Banerjee", "Sucheta Kripalani"],
      ans: 3
    },
    q6: {
      string: "6. Which political party did Atal Bihari Vajpayee belong to?",
      options: ["Indian National Congress", "Bharatiya Janata Party", "Communist Party of India", "Bahujan Samaj Party"],
      ans: 1
    },
    q7: {
      string: "7. Who was the Prime Minister of India during the Indo-Pak War of 1971?",
      options: ["Indira Gandhi", "Morarji Desai", "Atal Bihari Vajpayee", "Lal Bahadur Shastri"],
      ans: 0
    },
    q8: {
      string: "8. Which Indian state was the first to implement the Panchayati Raj system?",
      options: ["Rajasthan", "Maharashtra", "Kerala", "West Bengal"],
      ans: 3
    },
    q9: {
      string: "9. Who is the current President of India?",
      options: ["Ram Nath Kovind", "Pranab Mukherjee", "Narendra Modi", "Rahul Gandhi"],
      ans: 0
    },
    q10: {
      string: "10. Which Indian state was the first to achieve 100% primary education?",
      options: ["Kerala", "Tamil Nadu", "Gujarat", "Maharashtra"],
      ans: 0
    },
    q11: {
      string: "11. Who is the current Chief Minister of Delhi?",
      options: ["Arvind Kejriwal", "Manohar Lal Khattar", "Yogi Adityanath", "Mamata Banerjee"],
      ans: 0
    },
    q12: {
      string: "12. Who is known as the 'Iron Lady of India'?",
      options: ["Indira Gandhi", "Sonia Gandhi", "Mayawati", "Mamata Banerjee"],
      ans: 0
    },
    q13: {
      string: "13. Which of the following is NOT a recognized national political party in India?",
      options: ["Bahujan Samaj Party", "Shiv Sena", "Aam Aadmi Party", "Trinamool Congress"],
      ans: 2
    },
    q14: {
      string: "14. Who was the first Chief Minister of West Bengal?",
      options: ["Jyoti Basu", "Mamata Banerjee", "Bidhan Chandra Roy", "Prafulla Chandra Ghosh"],
      ans: 2
    },
    q15: {
      string: "15. Which Indian Prime Minister served the shortest term in office?",
      options: ["Atal Bihari Vajpayee", "Charan Singh", "Chandra Shekhar", "Inder Kumar Gujral"],
      ans: 3
    },
    q16: {
      string: "16. Which political party was founded by Mulayam Singh Yadav?",
      options: ["Samajwadi Party", "Rashtriya Janata Dal", "Biju Janata Dal", "Telugu Desam Party"],
      ans: 0
    },
    q17: {
      string: "17. Who is the youngest person to become Prime Minister of India?",
      options: ["Rajiv Gandhi", "P.V. Narasimha Rao", "Indira Gandhi", "Charan Singh"],
      ans: 0
    },
    q18: {
      string: "18. Who was the first Chief Minister of Uttar Pradesh?",
      options: ["Mayawati", "Mulayam Singh Yadav", "Kalyan Singh", "Govind Ballabh Pant"],
      ans: 3
    },
    q19: {
      string: "19. Which Indian state has the highest number of seats in the Lok Sabha?",
      options: ["Uttar Pradesh", "Maharashtra", "West Bengal", "Andhra Pradesh"],
      ans: 0
    },
    q20: {
      string: "20. Who was the first Chief Minister of Tamil Nadu?",
      options: ["M.G. Ramachandran", "J. Jayalalithaa", "C.N. Annadurai", "K. Kamaraj"],
      ans: 2
    },
    q21: {
      string: "21. Which Indian political party was founded by M.K. Stalin?",
      options: ["All India Anna Dravida Munnetra Kazhagam", "Dravida Munnetra Kazhagam", "All India Trinamool Congress", "Telugu Desam Party"],
      ans: 1
    },
    q22: {
      string: "22. Who is the current Chief Minister of Maharashtra?",
      options: ["Devendra Fadnavis", "Uddhav Thackeray", "Sharad Pawar", "Prithviraj Chavan"],
      ans: 1
    },
    q23: {
      string: "23. Who served as the Prime Minister of India for two consecutive terms?",
      options: ["Atal Bihari Vajpayee", "Indira Gandhi", "Manmohan Singh", "Narendra Modi"],
      ans: 3
    },
    q24: {
      string: "24. Who was the first Chief Minister of Bihar?",
      options: ["Krishna Singh", "Nitish Kumar", "Jagannath Mishra", "Sri Krishna Sinha"],
      ans: 3
    },
    q25: {
      string: "25. Which Indian state has the highest number of Legislative Assembly seats?",
      options: ["Uttar Pradesh", "Maharashtra", "West Bengal", "Andhra Pradesh"],
      ans: 0
    }
  };

  const [ques, setques] = useState(que.q1.string);
  const [opts, setoptions] = useState(que.q1.options);
  const [userAns, setUserAns] = useState(null);
  const [userAnswers, setUserAnswers] = useState(Array(25).fill(null));
  const [score, setScore] = useState(0);
  const [currentQuestion, setCurrentQuestion] = useState(1);
  const [timeLeft, setTimeLeft] = useState(900);
  let timer;
  useEffect(() => {
    timer = setInterval(() => {
      setTimeLeft(prevTime => {
        if (prevTime <= 1) {
          clearInterval(timer);
          submitTest();
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
  };

  const renderNext = () => {
    if (userAns !== null) {
      const newAnswers = [...userAnswers];
      newAnswers[currentQuestion - 1] = userAns;
      setUserAnswers(newAnswers);
    }
    setUserAns(null);
    let newCount = currentQuestion + 1;
    let newQue = que[`q${newCount}`]?.string;
    let newOpt = que[`q${newCount}`]?.options;
    if (newQue !== undefined) {
      setques(newQue);
      setoptions(newOpt);
      setCurrentQuestion(newCount);
    }
  };

  const renderPrevious = () => {
    if (userAns !== null) {
      const newAnswers = [...userAnswers];
      newAnswers[currentQuestion - 1] = userAns;
      setUserAnswers(newAnswers);
    }
    setUserAns(null);
    let newCount = currentQuestion - 1;
    let newQue = que[`q${newCount}`]?.string;
    let newOpt = que[`q${newCount}`]?.options;
    if (newQue !== undefined) {
      setques(newQue);
      setoptions(newOpt);
      setCurrentQuestion(newCount);
    }
  };

  const handleAnswer = (answerIndex) => {
    setUserAns(answerIndex);
  };

  const submitTest = () => {
    setTimeLeft(0);

    setUserAnswers((prevUserAnswers) => {
      const newAnswers = [...prevUserAnswers];
      if (userAns !== null) {
        newAnswers[currentQuestion - 1] = userAns;
      }

      let newScore = 0;
      for (let i = 0; i < 25; i++) {
        if (correctAnswers[i] === newAnswers[i]) {
          newScore++;
        }
      }
      setScore(newScore);

      return newAnswers;
    });
  };

  return (
    <div className={props.mode}>
      <div className="heading">
        <h1> KNOWLEDGE TEST ON <span>INDIAN POLITICS</span> </h1>
      </div>
      <div className="codingInformation">
        <div className="time">
          <h1>Time Left: {formatTime(timeLeft)}</h1> 
        </div>
        <div className="score">
          <span>Your Score: {score}</span>
        </div>
        <div className="tracker">
          <span>Track Your Question</span>
        </div>
      </div>
      <div className="mobileTracker">
        <span>Track Your Question</span>
      </div>
      <div className="mainCodingContainer">
        <div className="questionContainer">
          <p>{ques}</p>
          <div className="options">
            {opts.map((option, index) => (
              <div key={index} className={`opt${index + 1}`}>
                <input
                  type="radio"
                  name={`que${currentQuestion}`}
                  onChange={() => handleAnswer(index)}
                  checked={userAns === index}
                />
                <label>{option}</label>
              </div>
            ))}
          </div>
          <div className="btns">
            <button className="btn" onClick={renderPrevious}>Previous</button>
            <button className="btn" onClick={renderNext}>Next</button>
            <button className="btn" id="submitTest" onClick={submitTest}>Submit Test</button>
          </div>
          <div className="mobsub">
          <button className="btn" id="mobileSubmitTest" onClick={submitTest}>Submit Test</button>
          </div>
        </div>
        <div className="questionTrackerContainer">
          <div className="qtboxInformation">
            <div></div>
            <strong>Current</strong>
            <div></div>
            <strong id="solved">Solved</strong>
            <div></div>
            <strong id="unsolved">Unsolved</strong>
          </div>
          <div className="questionTracker">
            {[...Array(25)].map((_, i) => (
              <div
                key={i}
                className={`question ${currentQuestion === i + 1 ? 'current-question' : ''} ${userAnswers[i] !== null ? 'solved' : 'unsolved'}`}
              >
                {i + 1}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
